import { Expose } from "class-transformer";

export class TemplateModel {
  @Expose({ name: "templateCode" })
  TemplateCode?: string;

  @Expose({ name: "templateName" })
  TemplateName?: string;

  @Expose({ name: "templateType" })
  TemplateType?: string;

  constructor(templateCode?: string, templateName?: string) {
    this.TemplateCode = templateCode;
    this.TemplateName = templateName;
  }
}
